import { ForPaymentSettingsModel } from './typings/vendor-invoices.for-payment.settings';
import { InvoiceModel }            from '../invoices/models/invoice';
import { Table }                   from '../table/types/table';
import { TableQueryParameters }    from '../table/types/table-query-parameters';
import { TableService }            from '../table/table.service';
import { VendorPaymentsApiModel }  from '../vendor-payments/models/vendor-payment.api';
import { VendorModel }             from '../vendors/models/vendor';

export class VendorInvoicesForPaymentCtrl {
  areAllSelected            = false;
  selectedItems: Array<any> = [];

  tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.settings.tableCacheKey
    },
    columns: [
      {
        classes: 'text-left',
        field  : 'vendor_invoice_number',
        header : {
          text: this.$translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        },
      },
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: this.$translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-left',
        field  : 'total',
        header : {
          text: this.$translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-left',
        field  : 'balance_due',
        header : {
          text: this.$translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: this.$translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: this.tableApi.setSortingFromCache(this.settings.tableCacheKey, {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    }),
    static: true
  };

  constructor (
    private $translate       : ng.translate.ITranslateService,
    public  invoices         : Array<any>,
    private settings         : ForPaymentSettingsModel,
    private tableApi         : TableService,
    private vendor           : VendorModel,
    private vendorPaymentsApi: VendorPaymentsApiModel
  ) {}

  getInvoices ( params : TableQueryParameters ) : void {
    const isBranchPayment = this.settings.isBranchPayment || false;

    this.vendorPaymentsApi.getInvoicesForPayment(this.vendor, params, isBranchPayment)
    .then(( invoices : Array<InvoiceModel> ) => {
      this.invoices = invoices;
    });
  }

  handleInvoiceSelection () : void {
    this.selectedItems = this.invoices.filter(invoice => invoice.selected);

    this.areAllSelected = this.invoices.length === this.selectedItems.length;
  }

  toggleAll () : void {
    this.invoices.forEach(invoice => {
      invoice.selected = !this.areAllSelected;
    });

    this.areAllSelected = !this.areAllSelected;
    this.selectedItems  = this.areAllSelected
      ? this.invoices
      : [];
  }
}
